export enum FieldType {
  TEXT = 'text',
  BOOLEAN = 'boolean',
  INTEGER = 'integer',
  FLOAT = 'float',
  DATE = 'date',
  TIME = 'time',
  DATETIME = 'datetime',
  ENUM = 'enum',
  STATUS = 'status',
  GEAR = 'gear',
  LCD_STATUSES = 'lcdStatuses',
  LCD_VERSIONS = 'lcdVersions',
  DURATION = 'duration',
  EVENT_TYPE = 'eventType',
  AREA = 'area',
  ARRAY = 'array',
  DEVICE_ID = 'deviceId',
  AGID = 'agid',
  IRMA = 'irma',
  IRMA_CODE_DESCRIPTION = 'irmaCodeDescription',
  IRMA_STATUS_CODE = 'irmaStatusCode',
  IRMA_NUMBER = 'irmaNumber',
  VIOLATIONS_MARKER = 'violations-marker',
  VIOLATIONS_MARKER_2 = 'violations-marker2',
  VEHICLE_LAYOUT_TYPE = 'vehicleLayoutType',
  CRON = 'cron',
  CONST_VALUE = 'constValue',
  SWITCH = 'switch',
  VEHICLE_GROUP = 'vehicleGroup',
  DISPUTE_STATUS_FILTER = 'claimDisputeStatus',
  CONTRACT = 'contract',
  STOP_PILE_EVENT_TYPE_RAW = 'stopPileEventTypeRaw',
  STOP_PILE_EVENT_TYPE_STAT = 'stopPileEventTypeStat',
  VIOLATION_WITH_STATUS = 'violation-with-status'
}
